/************
 * Model Class
 * File Name ...: status-reasons.components.ts
 * Generated By : ianday on 12/13/23
 * Date ........: 12/13/23
 /************/
import {ValidationResult} from './validation-result';

export interface StatusReasons {
    id: number | null;
    description: string | null;
    activeStatus: string | null;
    requestStatusId: number | null;
}

export class StatusReasons {
    constructor() {
        this.id = 0;
        this.description = '';
        this.activeStatus = '';
        this.requestStatusId = 0;
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.description.length === 0) {
            vr.focus_field = 'description';                              /* this should be the id value of the field */
            vr.error = 'Error: a reason is required';
            return vr;
        }

        if(this.requestStatusId === 0) {
            vr.focus_field = 'requestStatusId';                              /* this should be the id value of the field */
            vr.error = 'Error: A Request Status is required ';
            return vr;
        }
        return vr;
    }
}
